export default __webpack_public_path__ + "static/media/AudacyLogo.8855b959.png";